import { keyMirror } from 'ramda-extension';

export const roles = keyMirror({
	ADMIN: null,
	REDAKTOR: null,
	USER: null,
});
